export const DUPLICATE_SEARCH = 'app/SearchManager/DUPLICATE_SEARCH'
export const DUPLICATE_SEARCH_SUCCESS =
  'app/SearchManager/DUPLICATE_SEARCH_SUCCESS'
export const DELETE_SAVED_SEARCH = 'app/SearchManager/DELETE_SAVED_SEARCH'
export const DELETE_SAVED_SEARCH_SUCCESS =
  'app/SearchManager/DELETE_SAVED_SEARCH_SUCCESS'
export const DELETE_SEARCH_AND_WIDGETS =
  'app/SearchManager/DELETE_SEARCH_AND_WIDGETS'
